<template>
    <v-container
        class="fill-height"
        fluid
        dark
        style="background-size: cover"
    >
    <v-snackbar v-model="sbEmail" :timeout="timeout" :top=true :absolute="true" color="#333333">
                            {{ mensajeSbEmail }}
                            <v-btn color="green" text small @click="sbEmail = false">
                                Cerrar
                            </v-btn>
                        </v-snackbar>
   
        <v-row
            align="center"
            justify="center"
        >
            <v-col
                cols="12"
                sm="8"
                md="4"
            >
                <v-col cols="12" class="text-center">
                    <img alt="Login" src="../../assets/images/fc-logo.png" style="width: 250px;">
                </v-col>
                <v-card class="elevation-12">
                    <v-card-text>
                        <v-col cols="12" class="text-center">Recuperar Contraseña </v-col>
                       
                        <v-form ref="formRequest">
                            <v-text-field
                                v-model="user"
                                label="Usuario / email"
                                prepend-icon="mdi-account"
                                type="text"
                                :rules=requiredRule
                            ></v-text-field>
                            
                        </v-form>
                    </v-card-text>
                    <v-spacer></v-spacer>
                    <v-col cols="12">
                        <v-btn 
                            color="primary" 
                            block
                            class="px-5"
                            @click="enviarAlerta"
                            :loading=loadingBtn
                        >
                            <v-icon>mdi-send</v-icon> Enviar codigo
                        </v-btn>
                    </v-col>
                    <v-row class="px-3">
                        <v-col cols="12" class="text-center">
                            <v-btn 
                                small 
                                text 
                                color="primary"
                                link
                                to="/login"
                            >
                              <v-icon>mdi-login</v-icon>   Regresar al inicio
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { ReplaceAroundStep } from 'prosemirror-transform';
import {mapActions, mapState, mapMutations} from 'vuex'

export default {
    name:'RecuperarContrasenaComponent',
    data: () =>({
        show: false,
        user:'',
        password:'',
        company:'',
        mensajeSbEmail: '',
        sbEmail:false,
        timeout: 30000,
        requiredRule:[
            v => !!v || 'El campo es requerido'
        ],
    }),
    computed:{
        ...mapState('master',['loadingBtn'])
    },
    
    methods:{

        ...mapMutations('master',['setUrl']),        
        ...mapActions('access',['recuperar']),

        ...mapActions("master", [ "alertNotification"]),
        enviarAlerta(){
            

            if (!this.$refs.formRequest.validate()) {
				return false;
			}

            this.recuperar({
                userName:this.user,
            }).then (
                (res) => {
                this.mensajeSbEmail = "Se ha enviado un email a: "+ res.data.email
                this.sbEmail = true
                }
                //this.alertNotification({param:{html: "Se ha enviado un email a: "+ res.data.email,"timeout":12000}})
                //console.log(res.data)
            )


            //mostrar correo al que se envio la alerta
            //bloquear botones y text input
            
            
        },
     
        mounted(){
     
            document.title = "Recuperar contraseña"
    
        }
    }
}
</script>

